import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { EssentialService } from '../../services/essential.service';

declare const $: any;
@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.css'],
})
export class DataGridComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;

  public APIData: any = [];
  public columns = [];
  public dataSource: any;
  public displayedColumns: string[];
  public pageSizeOptions: number[] = [5, 10, 25, 100];
  public site: any;

  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) public paginator: MatPaginator;

  constructor(private essentialsService: EssentialService) { }

  public ngOnInit() {
    this.site = this.data.moduleService.site;
    this.settings.colList = this.settings.colList || [];
    if (this.settings.pageSizeOptions) {
      this.pageSizeOptions = this.settings.pageSizeOptions;
    }
    this.getData();
  }

  public getData() {
    if (this.settings.apiLink) {
      this.essentialsService.getData(this.settings.apiLink).subscribe((res: any) => {
        this.APIData = [];
        if (this.settings.responseKeys) {
          const keys = this.settings.responseKeys.split('=>');
          let obj = res;
          for (const key of keys) {
            obj = obj[key] ? obj[key] : [];
          }
          this.APIData = obj ? obj : [];
        } else {
          this.APIData = res && res.length ? res : [];
        }
        if (this.settings.colList.length > 0) {
          for (const col of this.settings.colList) {
            this.columns.push({ columnDef: col.key, header: col.value, cell: (element: any) => `${element[col.key]}` });
          }
        }
        this.displayedColumns = this.columns.map((c) => c.columnDef);
        this.dataSource = new MatTableDataSource<any>(this.APIData);
        if (this.settings.sort) {
          this.dataSource.sort = this.sort;
        }
        if (this.settings.paging) {
          this.dataSource.paginator = this.paginator;
        }

      });
    }

  }
  public setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.settings.pageSizeOptions = setPageSizeOptionsInput.split(',').map((str) => +str);
  }
  public applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  public setJquryAndStyles() {
    this.setBordersAndShadow();
    $('ul.dropdown-menu.menu-' + this.settings.id + ' [data-toggle=\'dropdown\']').on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      let directionLeft = false;
      let opend = 'opend';
      if ($(this).offset().left > 1000) {
        directionLeft = true;
        opend = 'opend-left';
      }
      if ($(this).hasClass(opend)) {
        $(this).removeClass(opend);
      } else {
        $(this).toggleClass(opend);
      }

      if (directionLeft) {
        if ($(this).siblings().hasClass('left')) {
          $(this).siblings().removeClass('left');
        }
        $(this).siblings().toggleClass('left');
      }

      $(this).siblings().toggleClass('show');

      $(this).siblings().toggleClass(opend);

      if (!$(this).next().hasClass('show')) {
        $(this).parents('.dropdown-menu.menu-' + this.settings.id).first().find('.show').removeClass('show');
        $(this).parents('.dropdown-menu.menu-' + this.settings.id).first().find('.left').removeClass('left');
        $(this).parents('.dropdown-menu.menu-' + this.settings.id).first().find('.' + opend).removeClass(opend);
      }

      $(this).parents('li.nav-item.dropdown.' + 'show').on('hidden.bs.dropdown', () => {
        $('.dropdown-submenu .show').removeClass('show');
        $('.dropdown-submenu .show.left').removeClass('left');
        $('.dropdown-submenu .' + opend).removeClass(opend);
      });

    });

  }

  public setBordersAndShadow() {
    const nav = $('#nav-' + this.settings.id);
    if (this.settings.borderAll) {
      nav.css('border', this.settings.bordersize + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
    } else {
      if (this.settings.borderTop) {
        nav.css('border-top', this.settings.borderTop + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
      if (this.settings.borderTop) {
        nav.css('border-bottom', this.settings.borderBottom + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
      if (this.settings.borderTop) {
        nav.css('border-left', this.settings.borderLeft + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
      if (this.settings.borderTop) {
        nav.css('border-right', this.settings.borderRight + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
    }
    nav.css('box-shadow', this.settings.hoffset + 'px ' + this.settings.voffset + 'px ' + this.settings.blur + 'px ' + this.settings.spread + 'px ' + this.settings.boxcolor);
  }
}
